import React from 'react';

export default () => (
    <div className="page">
        <h1>配置要求</h1>
        <div>
            <p>此程序算法是由Java實現，故要成功運行，需下載安裝Java，只要版本在17以上即可。</p>
        </div>
    </div>
);
